<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<search-input
						:label="getMessage_('SWCC000206')"
						paramKey="pgmId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001537')"
						paramKey="jobGroupId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001536')"
						paramKey="jobId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001535')"
						paramKey="jobNm"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>						
				<el-col :span="3">
					<useYn-select />					
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/BatchStatus/store/helpers';
import SearchInput from './SearchInput.vue';
import UseYnSelect from './UseYnSelect.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {
			searchDate: ''
		};
	},
	components: { SearchInput, UseYnSelect },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getBatchStatusList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}		
	},
	async created() {
		try {			
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });

			let list = [];

			this.useYnList.forEach(row => {
				list.push({
					label: row.commCdName,
					value: row.commCd
				});
			});

			this.setState_({ key: 'gridUseYnList', value: list });
			//console.log('getStartDt_', this.getStartDt_);	
			
			await this.searchList();
			
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
		
	}
};
</script>

<style></style>
